<template>
  <div class="home-details">
    <page-header :title="title" />
    <div class="tag-home-container grey lighten-5 pa-3 pt-1 overflow-y-auto">
      <v-row class="mt-3" no-gutters>
        <v-col cols="12" sm="4" md="3" class="d-flex justify-center pa-0 ma-0">
          <div
            class="
              d-flex
              flex-fill
              justify-center justify-sm-start
              ml-1
              mb-2 mb-md-4
            "
          >
            <v-avatar
              v-if="tag.data.fotoPerfil === '::restrict::'"
              :size="
                $vuetify.breakpoint.smAndDown
                  ? '156'
                  : $vuetify.breakpoint.mdAndDown
                  ? '140'
                  : '160'
              "
              :tile="!$vuetify.breakpoint.smAndDown"
              @click="showPhotoFullscreen = false"
              :title="$t('restrito_usuario')"
            >
              <v-icon
                style="
                  position: absolute;
                  top: -40px;
                  left: -50px;
                  opacity: 0.65;
                "
                size="30"
                >mdi-lock</v-icon
              >
              <v-img style="opacity: 0.4" src="/img/person-avatar.png" alt="" />
            </v-avatar>
            <v-avatar
              v-else
              :size="
                $vuetify.breakpoint.smAndDown
                  ? '156'
                  : $vuetify.breakpoint.mdAndDown
                  ? '140'
                  : '160'
              "
              :tile="!$vuetify.breakpoint.smAndDown"
              @click="showPhotoFullscreen = true"
            >
              <div
                v-if="
                  $store.getters['tagFuncionario/isRestrict']('fotoPerfil') &&
                  $store.state.auth.user.token
                "
                style="position: absolute; top: 0; left: 0"
              >
                <v-icon
                  size="30px"
                  color="grey"
                  style="margin-bottom: 2px; opacity: 0.8"
                  dark
                  >mdi-lock</v-icon
                >
              </div>
              <v-img
                :src="
                  !tag.data.fotoPerfil
                    ? '/img/person-avatar.png'
                    : $store.state.profileImageURL + tag.data.fotoPerfil
                "
                alt=""
              />
            </v-avatar>
            <photo-fullscreen
              v-model="showPhotoFullscreen"
              :img="
                !tag.data.fotoPerfil
                  ? '/img/person-avatar.png'
                  : $store.state.profileImageURL + tag.data.fotoPerfil
              "
            />
          </div>
        </v-col>
        <v-col
          cols="12"
          sm="8"
          md="9"
          class="d-flex flex-column justify-start pl-sm-8 pl-lg-5 m-0"
        >
          <div v-if="tag.data.nome || !$store.state.hideNoFilled">
            <restrict-icon
              :is-restrict="$store.getters['tagFuncionario/isRestrict']('nome')"
            />
            <label class="text-caption grey--text text--darken-2">
              {{ $t("Nome_Completo") }}
            </label>
            <restrict-chip :value="tag.data.nome">
              <div v-if="tag.data.nome" class="title">
                {{ tag.data.nome }}
              </div>
              <div v-else>
                <i class="text-caption grey--text text--darken-1">
                  {{ noInfo }}
                </i>
              </div>
            </restrict-chip>
          </div>
          <div class="d-flex flex-wrap">
            <div
              v-if="tag.data.dataNasc || !$store.state.hideNoFilled"
              class="mr-6 my-2"
            >
              <restrict-icon
                :is-restrict="
                  $store.getters['tagFuncionario/isRestrict']('dataNasc')
                "
              />
              <label class="text-caption grey--text text--darken-2">
                {{ $t("Idade") }}
              </label>
              <restrict-chip :value="tag.data.dataNasc">
                <div v-if="tag.data.dataNasc" class="subtitle-2">
                  {{ tag.data.dataNasc | toAge }}
                </div>
                <div v-else>
                  <i class="text-caption grey--text text--darken-1">
                    {{ noInfo }}
                  </i>
                </div>
              </restrict-chip>
            </div>
            <div
              v-if="tag.data.peso || !$store.state.hideNoFilled"
              class="mr-6 my-2"
            >
              <restrict-icon
                :is-restrict="
                  $store.getters['tagFuncionario/isRestrict']('peso')
                "
              />
              <label class="text-caption grey--text text--darken-2">
                {{ $t("Peso") }}
              </label>
              <restrict-chip :value="tag.data.peso">
                <div v-if="tag.data.peso" class="subtitle-2">
                  {{ convertValue(tag.data.peso, { type: "decimal" }) }} Kg
                </div>
                <div v-else>
                  <i class="text-caption grey--text text--darken-1">
                    {{ noInfo }}
                  </i>
                </div>
              </restrict-chip>
            </div>
            <div
              v-if="tag.data.altura || !$store.state.hideNoFilled"
              class="mr-6 my-2"
            >
              <restrict-icon
                :is-restrict="
                  $store.getters['tagFuncionario/isRestrict']('altura')
                "
              />
              <label class="text-caption grey--text text--darken-2">
                {{ $t("Altura") }}
              </label>
              <restrict-chip :value="tag.data.altura">
                <div v-if="tag.data.altura" class="subtitle-2">
                  {{ convertValue(tag.data.altura, { type: "decimal" }) }} m
                </div>
                <div v-else>
                  <i class="text-caption grey--text text--darken-1">
                    {{ noInfo }}
                  </i>
                </div>
              </restrict-chip>
            </div>
            <div
              v-if="tag.data.tipoSangue || !$store.state.hideNoFilled"
              class="mr-6 my-2"
            >
              <restrict-icon
                :is-restrict="
                  $store.getters['tagFuncionario/isRestrict']('tipoSangue')
                "
              />
              <label class="text-caption grey--text text--darken-2">
                {{ $t("Tipo_Sangue") }}
              </label>
              <restrict-chip :value="tag.data.tipoSangue">
                <div v-if="tag.data.tipoSangue" class="subtitle-2">
                  {{ tag.data.tipoSangue }}
                </div>
                <div v-else>
                  <i class="text-caption grey--text text--darken-1">
                    {{ noInfo }}
                  </i>
                </div>
              </restrict-chip>
            </div>
            <v-col cols="12" class="m-0 d-flex">
              <div
                v-if="tag.data.empCarFun.cargo || !$store.state.hideNoFilled"
                class="mr-6 my-2"
              >
                <restrict-icon
                  :is-restrict="
                    $store.getters['tagFuncionario/isRestrict']('cargo')
                  "
                />
                <label class="text-caption grey--text text--darken-2">
                  {{ $t("Cargo") }}
                </label>
                <restrict-chip :value="tag.data.empCarFun.cargo">
                  <div v-if="tag.data.empCarFun.cargo" class="subtitle-2">
                    {{ tag.data.empCarFun.cargo.nome }}
                  </div>
                  <div v-else>
                    <i class="text-caption grey--text text--darken-1">
                      {{ noInfo }}
                    </i>
                  </div>
                </restrict-chip>
              </div>
              <div
                v-if="tag.data.empCarFun.funcao || !$store.state.hideNoFilled"
                class="mr-6 my-2"
              >
                <restrict-icon
                  :is-restrict="
                    $store.getters['tagFuncionario/isRestrict']('funcao')
                  "
                />
                <label class="text-caption grey--text text--darken-2">
                  {{ $t("Função") }}
                </label>
                <restrict-chip :value="tag.data.empCarFun.funcao">
                  <div v-if="tag.data.empCarFun.funcao" class="subtitle-2">
                    {{ tag.data.empCarFun.funcao.nome }}
                  </div>
                  <div v-else>
                    <i class="text-caption grey--text text--darken-1">
                      {{ noInfo }}
                    </i>
                  </div>
                </restrict-chip>
              </div>
            </v-col>
          </div>
        </v-col>
        <v-col cols="12" class="m-0">
          <div
            v-if="tag.data.email || !$store.state.hideNoFilled"
            class="d-flex flex-wrap"
          >
            <div class="mr-6 my-2">
              <restrict-icon
                :is-restrict="
                  $store.getters['tagFuncionario/isRestrict']('email')
                "
              />
              <label class="text-caption grey--text text--darken-2">
                {{ $t("Email") }}
              </label>
              <restrict-chip :value="tag.data.email">
                <div v-if="tag.data.email" class="subtitle-2">
                  {{ tag.data.email }}
                </div>
                <div v-else>
                  <i class="text-caption grey--text text--darken-1">
                    {{ noInfo }}
                  </i>
                </div>
              </restrict-chip>
            </div>
            <div
              v-if="tag.data.fone1Contato || !$store.state.hideNoFilled"
              class="mr-6 my-2"
            >
              <restrict-icon
                :is-restrict="
                  $store.getters['tagFuncionario/isRestrict']('fone1Contato')
                "
              />
              <label class="text-caption grey--text text--darken-2">
                {{ $t("Telefone_Contato") }}
              </label>
              <restrict-chip :value="tag.data.fone1Contato">
                <div v-if="tag.data.fone1Contato" class="subtitle-2">
                  {{ tag.data.fone1Contato }}
                </div>
                <div v-else>
                  <i class="text-caption grey--text text--darken-1">
                    {{ noInfo }}
                  </i>
                </div>
              </restrict-chip>
            </div>
            <div
              v-if="tag.data.nomeContato || !$store.state.hideNoFilled"
              class="mr-6 my-2"
            >
              <restrict-icon
                :is-restrict="
                  $store.getters['tagFuncionario/isRestrict']('nomeContato')
                "
              />
              <label class="text-caption grey--text text--darken-2">
                {{ $t("Nome_Contato") }}
              </label>
              <restrict-chip :value="tag.data.nomeContato">
                <div v-if="tag.data.nomeContato" class="subtitle-2">
                  {{ tag.data.nomeContato }}
                </div>
                <div v-else>
                  <i class="text-caption grey--text text--darken-1">
                    {{ noInfo }}
                  </i>
                </div>
              </restrict-chip>
            </div>
          </div>
        </v-col>
        <v-col cols="12" class="m-0">
          <div class="d-flex flex-wrap">
            <div
              v-if="tag.data.medicamentos || !$store.state.hideNoFilled"
              class="mr-6 my-2"
            >
              <restrict-icon
                :is-restrict="
                  $store.getters['tagFuncionario/isRestrict']('medicamentos')
                "
              />
              <label class="text-caption grey--text text--darken-2">
                {{ $t("Medicamentos") }}
              </label>
              <restrict-chip :value="tag.data.medicamentos">
                <div v-if="tag.data.medicamentos" class="subtitle-2">
                  {{ tag.data.medicamentos }}
                </div>
                <div v-else>
                  <i class="text-caption grey--text text--darken-1">
                    {{ noInfo }}
                  </i>
                </div>
              </restrict-chip>
            </div>
          </div>
        </v-col>
        <v-col cols="12" class="m-0">
          <div class="d-flex flex-wrap">
            <div
              v-if="tag.data.doencas || !$store.state.hideNoFilled"
              class="mr-6 my-2"
            >
              <restrict-icon
                :is-restrict="
                  $store.getters['tagFuncionario/isRestrict']('doencas')
                "
              />
              <label class="text-caption grey--text text--darken-2">
                {{ $t("Doencas") }}
              </label>
              <restrict-chip :value="tag.data.doencas">
                <div v-if="tag.data.doencas" class="subtitle-2">
                  {{ tag.data.doencas }}
                </div>
                <div v-else>
                  <i class="text-caption grey--text text--darken-1">
                    {{ noInfo }}
                  </i>
                </div>
              </restrict-chip>
            </div>
          </div>
        </v-col>
        <v-col cols="12" class="m-0">
          <div class="d-flex flex-wrap">
            <div
              v-if="tag.data.alergias || !$store.state.hideNoFilled"
              class="alergias mr-6 my-2"
            >
              <restrict-icon
                :is-restrict="
                  $store.getters['tagFuncionario/isRestrict']('alergias')
                "
              />
              <label class="text-caption grey--text text--darken-2">
                {{ $t("Alergias") }}
              </label>
              <restrict-chip :value="tag.data.alergias">
                <div v-if="tag.data.alergias" class="subtitle-2">
                  {{ tag.data.alergias }}
                </div>
                <div v-else>
                  <i class="text-caption grey--text text--darken-1">
                    {{ noInfo }}
                  </i>
                </div>
              </restrict-chip>
            </div>
          </div>
        </v-col>
        <v-col cols="12" class="m-0">
          <div class="d-flex flex-wrap">
            <div
              v-if="
                $i18n.i18next.language === 'pt_br' &&
                (tag.data.numeroSus || !$store.state.hideNoFilled)
              "
              class="mr-6 my-2"
            >
              <restrict-icon
                :is-restrict="
                  $store.getters['tagFuncionario/isRestrict']('numeroSus')
                "
              />
              <label class="text-caption grey--text text--darken-2">
                Número do SUS
              </label>
              <restrict-chip :value="tag.data.numeroSus">
                <div v-if="tag.data.numeroSus" class="subtitle-2">
                  {{ tag.data.numeroSus }}
                </div>
                <div v-else>
                  <i class="text-caption grey--text text--darken-1">
                    {{ noInfo }}
                  </i>
                </div>
              </restrict-chip>
            </div>
            <div
              v-if="tag.data.nomeMedico || !$store.state.hideNoFilled"
              class="mr-6 my-2"
            >
              <restrict-icon
                :is-restrict="
                  $store.getters['tagFuncionario/isRestrict']('nomeMedico')
                "
              />
              <label class="text-caption grey--text text--darken-2">
                {{ $t("Medico") }}
              </label>
              <restrict-chip :value="tag.data.nomeMedico">
                <div v-if="tag.data.nomeMedico" class="subtitle-2">
                  {{ tag.data.nomeMedico }}
                </div>
                <div v-else>
                  <i class="text-caption grey--text text--darken-1">
                    {{ noInfo }}
                  </i>
                </div>
              </restrict-chip>
            </div>
            <div
              v-if="tag.data.foneMedico || !$store.state.hideNoFilled"
              class="mr-6 my-2"
            >
              <restrict-icon
                :is-restrict="
                  $store.getters['tagFuncionario/isRestrict']('foneMedico')
                "
              />
              <label class="text-caption grey--text text--darken-2">
                {{ $t("Telefone_Medico") }}
              </label>
              <restrict-chip :value="tag.data.foneMedico">
                <div v-if="tag.data.foneMedico" class="subtitle-2">
                  {{ tag.data.foneMedico }}
                </div>
                <div v-else>
                  <i class="text-caption grey--text text--darken-1">
                    {{ noInfo }}
                  </i>
                </div>
              </restrict-chip>
            </div>
          </div>
        </v-col>
        <v-col cols="12" class="m-0">
          <div class="d-flex flex-wrap">
            <div
              v-if="tag.data.asoLink || !$store.state.hideNoFilled"
              class="mr-6 my-2"
            >
              <restrict-icon
                :is-restrict="
                  $store.getters['tagFuncionario/isRestrict']('asoLink')
                "
              />
              <label class="text-caption grey--text text--darken-2">
                {{ "ASO" }}
              </label>
              <restrict-chip :value="tag.data.asoLink">
                <div v-if="tag.data.asoLink" class="subtitle-2">
                  <v-btn
                    link
                    tag="a"
                    target="_blank"
                    :href="
                      $store.state.attachmentDocumentURL +
                      'aso/' +
                      tag.data.asoLink
                    "
                    elevation="0"
                    small
                    color="blue lighten-1"
                    text
                  >
                    <v-icon size="18" class="mr-1">mdi-open-in-new</v-icon>
                    {{ $t("visualizar") }}
                  </v-btn>
                </div>
                <div v-else>
                  <i class="text-caption grey--text text--darken-1">
                    {{ noInfo }}
                  </i>
                </div>
              </restrict-chip>
            </div>

            <div
              v-if="tag.data.asoDataExpiracao || !$store.state.hideNoFilled"
              class="mr-6 my-2"
            >
              <restrict-icon
                :is-restrict="
                  $store.getters['tagFuncionario/isRestrict'](
                    'asoDataExpiracao'
                  )
                "
              />
              <label class="text-caption grey--text text--darken-2">
                {{ "Data Expiração" }}
              </label>
              <restrict-chip :value="tag.data.asoDataExpiracao">
                <div v-if="tag.data.asoDataExpiracao" class="subtitle-2">
                  {{ tag.data.asoDataExpiracao | toLocaleDate }}
                </div>
                <div v-else>
                  <i class="text-caption grey--text text--darken-1">
                    {{ noInfo }}
                  </i>
                </div>
              </restrict-chip>
            </div>
          </div>
        </v-col>
        <v-col cols="12" class="m-0">
          <div class="d-flex flex-wrap">
            <div
              v-if="tag.data.informacoes || !$store.state.hideNoFilled"
              class="mr-6 my-2"
            >
              <restrict-icon
                :is-restrict="
                  $store.getters['tagFuncionario/isRestrict']('informacoes')
                "
              />
              <label class="text-caption grey--text text--darken-2">
                {{ $t("Outras_Informacoes") }}
              </label>
              <restrict-chip :value="tag.data.informacoes">
                <div v-if="tag.data.informacoes" class="subtitle-2">
                  {{ tag.data.informacoes }}
                </div>
                <div v-else>
                  <i class="text-caption grey--text text--darken-1">
                    {{ noInfo }}
                  </i>
                </div>
              </restrict-chip>
            </div>
          </div>
        </v-col>
      </v-row>
    </div>
    <Form :title="title" :data="tag" />
  </div>
</template>

<script>
/* eslint-disable prettier/prettier */
import i18next from "i18next";
import MixinGlobal from "@/mixins";
import PageHeader from "@/components/headers/page-header";
import PhotoFullscreen from "@/components/modals/photo-fullscreen";
import Form from "./form";
import RestrictChip from "@/components/chips/restrict-chip";
import RestrictIcon from "@/components/icons/restrict-icon";

export default {
  metaInfo: {
    titleTemplate: (i18next.t("Perfil") || "") + " | %s",
  },
  mixins: [MixinGlobal],
  components: { RestrictIcon, RestrictChip, PhotoFullscreen, PageHeader, Form },
  data: () => ({
    noInfo: "__",
    title: i18next.t("Perfil"),
    showPhotoFullscreen: false,
  }),
  computed: {
    store() {
      return this.$store.state;
    },
    tag() {
      return this.$store.state.tagFuncionario;
    },
  },
  mounted() {
    this.$nextTick(this.checkFilled);
  },
  methods: {
    checkFilled() {
      const filleds = [
        "nome",
        "dataNasc",
        "peso",
        "altura",
        "tipoSangue",
        "email",
        "fone1Contato",
        "nomeContato",
        "medicamentos",
        "doencas",
        "numeroSus",
        "nomeMedico",
        "foneMedico",
        "informacoes",
        "asoLink",
        "asoDataExpiracao",
      ].map((key) => {
        return !!this.tag.data[key];
      });

      this.$store.commit("setAllFilled", !filleds.includes(false));
    },
  },
};
</script>

<style lang="scss">
.tag-home {
  @media (min-width: 1025px) {
    &-container {
      height: 580px;
      min-height: 580px;
      max-height: 580px;
    }
  }

  .v-avatar {
    background-color: #fff;
    border: solid 1px #e5e5e5;
  }
}
</style>
